import api from './api';

/**
 * Reads all runrora_* keys from localStorage, POSTs them to /api/migrate,
 * and clears them on success. Called after first login/register when legacy data exists.
 */
export async function migrateLegacyData() {
  try {
    // Check if there's any legacy data worth migrating
    const storedRegs = localStorage.getItem('runrora_registrations');
    if (!storedRegs) return; // Nothing to migrate

    const registrations = [];
    const checklists = [];
    const travel = [];
    const strategies = [];
    const mantras = [];

    // Parse registrations — format is { raceId: [{ user_id, ... }] }
    const regsMap = JSON.parse(storedRegs);
    const raceIds = Object.keys(regsMap).filter(id => regsMap[id]?.length > 0);

    for (const raceId of raceIds) {
      registrations.push({ raceId: parseInt(raceId) });
    }

    // For each race, gather prep data
    for (const key of Object.keys(localStorage)) {
      const checklistMatch = key.match(/^runrora_checklist_(\d+)$/);
      if (checklistMatch) {
        const raceId = parseInt(checklistMatch[1]);
        const items = JSON.parse(localStorage.getItem(key) || '[]');
        if (items.length > 0) {
          checklists.push({
            raceId,
            items: items.map((item, i) => ({
              text: item.text,
              completed: item.completed || false,
              sortOrder: item.order || i,
            })),
          });
        }
      }

      const travelMatch = key.match(/^runrora_travel_(\d+)$/);
      if (travelMatch) {
        const raceId = parseInt(travelMatch[1]);
        const items = JSON.parse(localStorage.getItem(key) || '[]');
        if (items.length > 0) {
          travel.push({
            raceId,
            items: items.map(item => ({
              type: item.type || 'other',
              details: item.details,
              date: item.date || null,
              confirmation: item.confirmation || null,
            })),
          });
        }
      }

      const mantraMatch = key.match(/^runrora_mantra_(\d+)$/);
      if (mantraMatch) {
        const raceId = parseInt(mantraMatch[1]);
        const text = localStorage.getItem(key);
        if (text) {
          mantras.push({ raceId, text });
        }
      }

      const timeGoalMatch = key.match(/^runrora_timegoal_(\d+)$/);
      if (timeGoalMatch) {
        const raceId = parseInt(timeGoalMatch[1]);
        const timeGoal = localStorage.getItem(key) || '';
        const fuelPlan = localStorage.getItem(`runrora_fuelplan_${raceId}`) || '';
        const raceStrategy = localStorage.getItem(`runrora_strategy_${raceId}`) || '';
        if (timeGoal || fuelPlan || raceStrategy) {
          // Avoid duplicates if we already processed this race via fuelplan or strategy key
          if (!strategies.find(s => s.raceId === raceId)) {
            strategies.push({ raceId, timeGoal, fuelPlan, raceStrategy });
          }
        }
      }
    }

    if (registrations.length === 0 && checklists.length === 0 && travel.length === 0 && strategies.length === 0 && mantras.length === 0) {
      return;
    }

    await api.post('/migrate', { registrations, checklists, travel, strategies, mantras });

    // Clear legacy data on success
    const keysToRemove = Object.keys(localStorage).filter(k =>
      k.startsWith('runrora_') && k !== 'runrora_race_ready'
    );
    keysToRemove.forEach(k => localStorage.removeItem(k));

    console.log('Legacy data migrated successfully.');
  } catch (err) {
    console.error('Legacy data migration failed (will retry next login):', err);
  }
}
